import React, { useEffect, useState, useCallback } from 'react';
import { Snackbar, Alert, Fade } from '@mui/material';
import {
	SPEECH_TRANSCRIPTION_NOTIFY_EVENT,
	type SpeechTranscriptionNotifyDetail,
} from '../../services/speechTranscriptionNotify';

/**
 * Ses-metin hatalarını ekran ortasında Snackbar ile gösterir (web ve tablet).
 */
export default function SpeechTranscriptionSnackbarHost() {
	const [toast, setToast] = useState<
		(SpeechTranscriptionNotifyDetail & { open: boolean }) | null
	>(null);

	useEffect(() => {
		const onNotify = (e: Event) => {
			const ce = e as CustomEvent<SpeechTranscriptionNotifyDetail>;
			if (!ce.detail?.message) return;
			setToast({ ...ce.detail, open: true });
		};
		window.addEventListener(SPEECH_TRANSCRIPTION_NOTIFY_EVENT, onNotify);
		return () => window.removeEventListener(SPEECH_TRANSCRIPTION_NOTIFY_EVENT, onNotify);
	}, []);

	const handleClose = useCallback(() => {
		setToast((t) => (t ? { ...t, open: false } : null));
	}, []);

	const dismiss = useCallback(() => {
		setToast((t) => (t ? { ...t, open: false } : null));
	}, []);

	if (!toast) {
		return null;
	}

	return (
		<Snackbar
			open={toast.open}
			autoHideDuration={8000}
			onClose={handleClose}
			TransitionComponent={Fade}
			TransitionProps={{
				onExited: () => setToast(null),
			}}
			anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
			sx={{
				top: '50%',
				left: '50%',
				right: 'auto',
				bottom: 'auto',
				transform: 'translate(-50%, -50%)',
				maxWidth: { xs: 'calc(100vw - 24px)', sm: 520 },
				width: { xs: 'calc(100vw - 24px)', sm: 'min(520px, calc(100vw - 48px))' },
			}}
		>
			<Alert
				onClose={dismiss}
				severity={toast.severity}
				variant="outlined"
				elevation={0}
				sx={(theme) => ({
					width: '100%',
					alignItems: 'flex-start',
					boxSizing: 'border-box',
					borderRadius: 2,
					fontSize: { xs: '0.9375rem', sm: '0.875rem' },
					lineHeight: 1.45,
					px: { xs: 2, sm: 2 },
					py: 1.25,
					backgroundColor: theme.palette.background.paper,
					boxShadow: theme.shadows[4],
				})}
			>
				{toast.message}
			</Alert>
		</Snackbar>
	);
}
